import http from 'lib/utils/axios';

const PROJECT_URL = '/project/';

export const fetch = () => http.get(PROJECT_URL);
export const create = payload => http.post(PROJECT_URL, payload);
export const update = (payload) => http.put(`${PROJECT_URL}${payload.projectId}`, payload);

export default {
  fetch,
  create,
  update,
};
